import { render, staticRenderFns } from "./EgrantyIconButton.vue?vue&type=template&id=3456075c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./EgrantyIconButton.vue?vue&type=script&lang=js&"
export * from "./EgrantyIconButton.vue?vue&type=script&lang=js&"
import style0 from "./EgrantyIconButton.vue?vue&type=style&index=0&id=3456075c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3456075c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VTooltip})
